import { render, staticRenderFns } from "./DocsView.vue?vue&type=template&id=7914ebbc&scoped=true"
import script from "./DocsView.vue?vue&type=script&lang=js"
export * from "./DocsView.vue?vue&type=script&lang=js"
import style0 from "./DocsView.vue?vue&type=style&index=0&id=7914ebbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7914ebbc",
  null
  
)

export default component.exports